module.exports = __webpack_public_path__ + "img/1586460620.9e6df422.jpg";